import { combineReducers } from 'redux';
import user from './user-reducer';
import customer from './customer-reducer';
import  authentication from './authentication-reducer'

const rootReducer = combineReducers({
    authentication, user, customer
});

export default rootReducer;